import { Map } from 'immutable';

import { DROPDOWN_KEY } from '../constants/Dropdown';
import { ViewActions } from '../constants/ViewActions';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [DROPDOWN_KEY]: [],
});

// DROPDOWN REDUCER
export default createReducer(INITIAL_STATE, {
  [ViewActions.OPEN_DROPDOWN]: openDropdown,
  [ViewActions.CLOSE_DROPDOWN]: closeDropdown,
});

// CASE FUNCTIONS

function openDropdown(state, action) {
  return Map({
    [DROPDOWN_KEY]: action.dropdownConfiguration,
  });
}

function closeDropdown() {
  return INITIAL_STATE;
}
